import { render, staticRenderFns } from "./SingleTestView.vue?vue&type=template&id=2cf09cd6&scoped=true&"
import script from "./SingleTestView.vue?vue&type=script&lang=js&"
export * from "./SingleTestView.vue?vue&type=script&lang=js&"
import style0 from "./SingleTestView.vue?vue&type=style&index=0&id=2cf09cd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf09cd6",
  null
  
)

export default component.exports